// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__kLzvJ","content":"styles_content__1tNr5","intro":"styles_intro__2aAGA"};